import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaLock } from "react-icons/fa";

import { technologyIcon } from "../assessment/technologyIcon";
import RequestQuizModal from "../../../QuizStudio/component/common/RequestQuizModal";
import Badge from "../../../ReusableComponent/Badge";
import Button from "../../../ReusableComponent/Button";

const AssessmentCardVerified = ({ quizTestsList }) => {
  const [availableAssessments, setAvailableAssessments] = useState([]);

  useEffect(() => {
    if (quizTestsList) {
      const filteredTests = quizTestsList?.filter(
        (item) =>
          item?.quizCategory === "assessment" &&
          item?.isAttempted === false &&
          item?.quizQuestions?.length > 0
      );

      setAvailableAssessments(filteredTests);
    }
  }, [quizTestsList]);

  return (
    <div className="row mx-0 d-flex justify-content-center align-items-center">
      <div className="col-12 mx-0">
        <h2 className="py-3 fs-5">Available Skill Assesments</h2>
        <div className="row mx-0">
          {availableAssessments.length > 0 ? (
            availableAssessments.map((quiz, index) => {
              const hasQuestions = quiz.quizQuestions?.length > 0;
              const quizTechnology = quiz?.quizTechnology?.toLowerCase();
              const iconUrl = technologyIcon.find(
                (item) =>
                  item?.technologyName?.toLowerCase() === quizTechnology
              );
              return (
                <>
                  <div className="col-12 col-md-4 px-0">
                    <div
                      key={quiz._id || index}
                      className="Assessment-card-manage mt-3 "
                    >
                      <div className="card m-lg-2 ">
                        <div className="card-body">
                          <div className="d-flex justify-content-start align-items-start w-100">
                            <img
                              src={
                                iconUrl?.technologyIconImageUrl
                                  ? iconUrl?.technologyIconImageUrl
                                  : "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg"
                              }
                              alt="..."
                              height={50}
                              width={50}
                              className="me-3"
                            />
                            <div className="d-flex flex-column m-0 p-0 w-100">
                              <h2 className="fs-md-16 fs-16 mb-0 text-capitalize mb-0">
                                {quiz?.quizTitle}
                              </h2>
                              {/* badge modify */}
                              {/* <span className="status-badge text-capitalize invited rounded-pill fs-md-6 fs-8 px-md-5 py-2"> 
                                    {quiz?.access === "invite" ? quiz?.invited ?
                                      <div className={`${quiz?.inviteStatus.toLowerCase() === "pending" ? "text-success" : "text-danger"}`}>
                                        {quiz?.inviteStatus}
                                      </div> :
                                      <><FaLock className="me-1" size={14} />Invite Only</> :
                                      "Public"}
                                  </span> */}
                              <span className="mt-0 text-light fs-14">
                                <i className="bi bi-clock me-2" />
                                {quiz?.duration} minutes
                              </span>
                              <span className="mt-0 text-light fs-14">
                                <i class="bi bi-question-square me-2" />
                                {quiz?.quizQuestions?.length} Questions
                              </span>
                            </div>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-4 w-100">
                            <Badge color="info" pill>
                              {quiz?.access === "invite" ? (
                                quiz?.invited ? (
                                  <span
                                    className={
                                      quiz?.inviteStatus.toLowerCase() ===
                                        "pending"
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {quiz?.inviteStatus}
                                  </span>
                                ) : (
                                  <>
                                    <FaLock className="me-1" size={14} />{" "}
                                    Invite Only
                                  </>
                                )
                              ) : (
                                "Public"
                              )}
                            </Badge>
                            <Link
                              to={
                                hasQuestions
                                  ? `/assessments/${quiz._id}`
                                  : "/assessments"
                              }
                              onClick={(e) => {
                                if (!hasQuestions) e.preventDefault();
                              }}
                            >
                              {quiz?.access == "invite" && !quiz?.invited ? (
                                <buttton className="btn text-white bg-primary">
                                  <RequestQuizModal label="Request Quiz" quiz={quiz}/>
                                </buttton>
                              ) : (
                                <Button
                                  className="py-2 fw-normal"
                                  variant="primary"
                                  size="md"
                                  disabled={!hasQuestions}
                                >
                                  Start Assessment
                                </Button>
                              )}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <div className="col-12 text-center mt-3">
              <p>No Assessments available !!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentCardVerified;
